import { IIndexable, key } from 'core-ts-types';

export class DisplayMessage implements IIndexable {

  id: key = 0;
  key: string = '';
  name: string = '';
  description: string = '';
  text: string = '';
  is_rich_content: boolean = false;
  add_contact_counselor_link: boolean = false;

  constructor(object: any) {
    _.merge(this, object);
  }

  static build(object: any) {
    return new DisplayMessage(object);
  }
}

angular.module('capability-ng-global')
.factory('ngDisplayMessageBuilder', (): typeof DisplayMessage => {
  return DisplayMessage;
});



// WEBPACK FOOTER //
// ./app/lib/global/builders/display_message_builder.ts